import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {TrustiiService} from 'src/app/services/trustii.service';
import {DialogService} from 'src/app/services/dialog.service';
import {saveAs} from 'file-saver';
import { Router } from '@angular/router';
import { DataService, DatasetBannerModel } from 'src/app/services/data.service';

@Component({
  selector: 'app-conditions-dialog',
  templateUrl: './conditions-dialog.component.html',
  styleUrls: ['./conditions-dialog.component.scss']
})
export class ConditionsDialogComponent {
  public datasets: any[];
  downloading = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { name: string },
    private dialogRef: MatDialogRef<ConditionsDialogComponent>,
    private router: Router,
    public dataservice: DataService,
    public dataetBannerModel: DatasetBannerModel
  ) {
    const defaultValues = {
      dataset: null,
    };
    const values: any = {
      ...defaultValues,
      ...data,
    };

    this.datasets = values.datasets;
  }

  closeDialog() {
    this.dialogRef.close({data: 'confirmation'});
  }

  openDatasetPortal(datasetObject) {
    Object.assign(this.dataetBannerModel.dataset, datasetObject);
    Object.assign(this.dataservice.data, datasetObject);
    this.router.navigateByUrl('datasets/' + datasetObject.id);
    this.dialogRef.close({data: 'confirmation'});
  }
}
